import request from '@/utils/http.js';

const getTopicList = params => {
  return request({
    url: '/v3/vss/chatbot/get-topic-list',
    // url: '/mock/101/v3/vss/chatbot/get-topic-list',
    method: 'POST',
    data: {
      ...params
    }
  });
};

const startPushTopic = params => {
  return request({
    url: '/v3/vss/chatbot/start-push-topic',
    method: 'POST',
    data: {
      ...params
    }
  });
};

const stopPushTopic = params => {
  return request({
    url: '/v3/vss/chatbot/end-push-topic',
    method: 'POST',
    data: {
      ...params
    }
  });
};

const getVirtualList = params => {
  return request({
    // url: '/mock/101/v3/vss/chatbot/get-virtual-audience-list',
    url: '/v3/vss/chatbot/get-virtual-audience-list',
    method: 'POST',
    data: {
      ...params
    }
  });
};

const getBotList = params => {
  return request({
    // url: '/mock/101/v3/vss/chatbot/get-chatbot-list',
    url: '/v3/vss/chatbot/get-chatbot-list',
    method: 'POST',
    data: {
      ...params
    }
  });
};

const pushMessage = params => {
  return request({
    url: '/v3/vss/chatbot/push-message',
    method: 'POST',
    data: {
      ...params
    }
  });
};

//发起端-聊天-获取常用语列表
const getPhraseList = params => {
  return request({
    url: '/v3/vss/chat/get-phrase-list',
    method: 'POST',
    data: {
      ...params
    }
  });
}
//发起端-聊天-保存常用语
const savePhrase = params => {
  return request({
    url: '/v3/vss/chat/save-phrase',
    method: 'POST',
    data: {
      ...params
    }
  });
}
//发起端-聊天-删除常用语
const deletePhrase = params => {
  return request({
    url: '/v3/vss/chat/delete-phrase',
    method: 'POST',
    data: {
      ...params
    }
  });
}
//发起端-AI聊天-推送机器人消息
const pushChatbotMessage = params => {
  return request({
    url: '/v3/vss/chatbot/push-message',
    method: 'POST',
    data: {
      ...params
    }
  });
}
export default {
  getTopicList,
  startPushTopic,
  stopPushTopic,
  getVirtualList,
  pushMessage,
  getBotList,
  getPhraseList,
  savePhrase,
  deletePhrase,
  pushChatbotMessage
};
